import { render, staticRenderFns } from "./DeliveryBoyList.vue?vue&type=template&id=337c9adb&"
import script from "./DeliveryBoyList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBoyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337c9adb')) {
      api.createRecord('337c9adb', component.options)
    } else {
      api.reload('337c9adb', component.options)
    }
    module.hot.accept("./DeliveryBoyList.vue?vue&type=template&id=337c9adb&", function () {
      api.rerender('337c9adb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/DeliveryBoyList.vue"
export default component.exports